import {isApiException} from '@dms/api/utils';

import {ApiError, isFetchBaseQueryError} from 'shared/web';

import {PROMO_PHOTO_FILE_NOT_FOUND_ERROR_CODE} from '../constants/PROMO_PHOTO_FILE_NOT_FOUND_ERROR_CODE';

export const isPromoPhotoFileNotFoundError = (error: ApiError): boolean =>
  isFetchBaseQueryError(error) &&
  isApiException(error.data) &&
  error.data.errors.some((apiError) => apiError.code === PROMO_PHOTO_FILE_NOT_FOUND_ERROR_CODE);
